import React from 'react';
import { Button, Typography, IconButton } from '@material-ui/core';
import { makeStyles, fade } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
  grow: {
    flexGrow: 1,
    fontSize: '1.6rem',
    fontWeight: 'bold',
  },
  btnChangeBg: {
    color: '#fff',
    background: 'hsla(0,0%,100%,.24)',
  },
}));
export default function TopBar({ toggleDrawer }) {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <Typography className={classes.grow}>Daily Todo</Typography>
      <Button className={classes.btnChangeBg} onClick={toggleDrawer}>
        Change background
      </Button>
    </div>
  );
}
